import CompareTargetSection from '../../components/CompareTargetSection';
import { useUtComparisonElecStore } from '../store/useUtComparisonElecStore';

/**
 * ① 비교 대상 UT Matrix — 이 화면이 어떤 UT Matrix를 비교했는지 보여주기만 한다.
 *
 * [26.09.23] 행추가 / 초기화 / 분석시작 버튼을 걷어냈다(더 이상 쓰지 않는 기능).
 * 그에 딸려 있던 것들도 같이 없앴다 — UT Matrix 선택 모달(행추가 전용)과
 * 행별 선택 해제(✕) 열. 기계 탭 UtMatrixSelector와 같은 정리다.
 *
 * 섹션 자체는 기계 탭과 공용이다(CompareTargetSection) — 스토어만 여기서 붙여 준다.
 */
const UtMatrixElecSelector = () => {
  const selectedMatrices = useUtComparisonElecStore((s) => s.selectedMatrices);
  const historyRptId = useUtComparisonElecStore((s) => s.historyRptId);

  return (
    <CompareTargetSection
      matrices={selectedMatrices}
      historyRptId={historyRptId}
      emptyClassName="empty"
      bodyClassName="pane-body"
    />
  );
};

export default UtMatrixElecSelector;
